export enum Persona {
  PLATFORM_ADMIN = 'PlatformAdmin',
  BUSINESS_UNIT_ADMIN = 'BusinessUnitAdmin',
  CONTENT_ADMIN = 'ContentAdmin',
  AUDIT_ADMIN = 'AuditAdmin',
  SUPER_AUDITOR = 'SuperAuditor',
  AUDITOR = 'Auditor',
  TASK_MANAGER = 'TaskManager',
}
